const carsTypes = {
    GET_CARS_DATA : 'GET_CARS_DATA',
    CAR_SELECTED : 'CAR_SELECTED',
    CAR_SELECTED_INFO: 'CAR_SELECTED_INFO',
    REMOVE_CAR_SELECTED_INFO: 'REMOVE_CAR_SELECTED_INFO',
    GET_CARS_DATA_NEEDED: 'GET_CARS_DATA_NEEDED',
    REMOVE_CARS_DATA: 'REMOVE_CARS_DATA',
    GET_REPORTS : 'GET_REPORTS',
    CHANGE_DAY: 'CHANGE_DAY',
    GET_SINGLE_CAR_DATA: 'GET_SINGLE_CAR_DATA',
    SET_ICONS : 'SET_ICONS',
    PLAY_PAUSE : 'PLAY_PAUSE',
    SET_INTERVAL: 'SET_INTERVAL',
    SET_REPORT_INDEX: 'SET_REPORT_INDEX',
    SET_REPORT_SPEED: 'SET_REPORT_SPEED',
    SET_ARROW_ICON: 'SET_ARROW_ICON',
    SET_START_REP_TIME: 'SET_START_REP_TIME',
    SET_END_REP_TIME: 'SET_END_REP_TIME',
    ADD_HOLDOVER_CAR: 'ADD_HOLDOVER_CAR',
    REMOVE_HOLDOVER_CAR: 'REMOVE_HOLDOVER_CAR',
    CLEAR_HOLDOVER_CARS: 'CLEAR_HOLDOVER_CARS',
    SET_HOLDOVER_CARS: 'SET_HOLDOVER_CARS',
    SET_ALL_DEVICE_INFO: "SET_ALL_DEVICE_INFO",
    SET_IS_WITH_OUT_POINT: 'SET_IS_WITH_OUT_POINT'
};

export default carsTypes;